import { useEffect } from 'react';
import {
  disableClosingConfirmation,
  enableClosingConfirmation,
  isClosingBehaviorMounted,
  mountClosingBehavior,
} from '@telegram-apps/sdk-react';
import { insideTelegram, safe } from './env';

/**
 * Пока в форме есть несохранённое, клиент переспросит при закрытии.
 * Иначе смахнул окно — и трата потерялась.
 */
export function useClosingConfirmation(active: boolean): void {
  useEffect(() => {
    if (!insideTelegram() || !mountClosingBehavior.isAvailable()) return;

    safe(() => {
      if (!isClosingBehaviorMounted()) mountClosingBehavior();
    });

    if (active) safe(() => enableClosingConfirmation());
    else safe(() => disableClosingConfirmation());

    return () => {
      safe(() => disableClosingConfirmation());
    };
  }, [active]);
}
